import { render, staticRenderFns } from "./FactumAppealBookCertificateAppLeaveGrantedPg.vue?vue&type=template&id=5155093b&scoped=true"
import script from "./FactumAppealBookCertificateAppLeaveGrantedPg.vue?vue&type=script&lang=ts"
export * from "./FactumAppealBookCertificateAppLeaveGrantedPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5155093b",
  null
  
)

export default component.exports